import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { FileText, Receipt, Eye } from 'lucide-react';

const SimpleEmpty = ({ icon, text }) => (
  <Card className="bg-[#0d3d3d]/60 border-white/10">
    <CardContent className="py-10 text-center text-white/60">
      {icon}
      <p className="text-sm">{text}</p>
    </CardContent>
  </Card>
);

export const MyQuotesList = ({ quotes, navigate, i18n, fmtEuro }) => {
  if (!quotes.length) {
    return (
      <div className="max-w-7xl mx-auto mb-8">
        <SimpleEmpty icon={<FileText className="w-10 h-10 mx-auto mb-2 text-white/30" />} text={i18n.language === 'nl' ? 'U heeft nog geen offertes.' : 'You have no quotes yet.'} />
      </div>
    );
  }
  return (
    <div className="max-w-7xl mx-auto mb-8" data-testid="client-quotes-section">
      <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-2">
        <FileText className="w-6 h-6 text-[#3da5a5]" /> {i18n.language === 'nl' ? 'Mijn Offertes' : 'My Quotes'} ({quotes.length})
      </h2>
      <div className="grid gap-3">
        {quotes.map((q) => (
          <Card key={q.id} className="bg-[#0d3d3d]/90 border-white/20">
            <CardContent className="py-4 flex items-center justify-between flex-wrap gap-3">
              <div>
                <p className="font-bold text-white">{q.number}</p>
                <p className="text-xs text-white/60">{q.offer_date} · {q.status}</p>
              </div>
              <div className="flex items-center gap-3">
                <p className="font-bold text-[#3da5a5]">{fmtEuro(q.total)}</p>
                {q.public_token && (
                  <Button
                    size="sm"
                    variant="outline"
                    className="border-white/30 text-white hover:bg-white/10"
                    onClick={() => navigate(`/offerte/${q.public_token}?from=portal`)}
                    data-testid={`client-view-quote-${q.id}`}
                  >
                    <Eye className="w-4 h-4 mr-1" />
                    {i18n.language === 'nl' ? 'Bekijken' : 'View'}
                  </Button>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export const MyInvoicesList = ({ invoices, navigate, i18n, fmtEuro }) => {
  if (!invoices.length) {
    return (
      <div className="max-w-7xl mx-auto mb-8">
        <SimpleEmpty icon={<Receipt className="w-10 h-10 mx-auto mb-2 text-white/30" />} text={i18n.language === 'nl' ? 'U heeft nog geen facturen.' : 'You have no invoices yet.'} />
      </div>
    );
  }
  return (
    <div className="max-w-7xl mx-auto mb-8" data-testid="client-invoices-section">
      <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-2">
        <Receipt className="w-6 h-6 text-[#3da5a5]" /> {i18n.language === 'nl' ? 'Mijn Facturen' : 'My Invoices'} ({invoices.length})
      </h2>
      <div className="grid gap-3">
        {invoices.map((inv) => (
          <Card key={inv.id} className="bg-[#0d3d3d]/90 border-white/20">
            <CardContent className="py-4 flex items-center justify-between flex-wrap gap-3">
              <div>
                <p className="font-bold text-white">{inv.number}</p>
                <p className="text-xs text-white/60">{inv.invoice_date} · {inv.status}</p>
              </div>
              <div className="flex items-center gap-3">
                <p className="font-bold text-[#3da5a5]">{fmtEuro(inv.total_incl || inv.total)}</p>
                {inv.public_token && (
                  <Button
                    size="sm"
                    variant="outline"
                    className="border-white/30 text-white hover:bg-white/10"
                    onClick={() => navigate(`/factuur/${inv.public_token}?from=portal`)}
                    data-testid={`client-view-invoice-${inv.id}`}
                  >
                    <Eye className="w-4 h-4 mr-1" />
                    {i18n.language === 'nl' ? 'Bekijken' : 'View'}
                  </Button>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default MyQuotesList;
